import { render, staticRenderFns } from "./Inteligencia.vue?vue&type=template&id=4a33bb1a&scoped=true&lang=pug"
import script from "./Inteligencia.vue?vue&type=script&lang=js"
export * from "./Inteligencia.vue?vue&type=script&lang=js"
import style0 from "./Inteligencia.vue?vue&type=style&index=0&id=4a33bb1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a33bb1a",
  null
  
)

export default component.exports